import { Link, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
  createCustomer,
  fetchCustomer,
  updateCustomer,
} from '../services/api';

const emptyForm = { name: '', code: '', note: '' };

export default function CustomerFormPage() {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const navigate = useNavigate();

  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(isEdit);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isEdit) return undefined;
    let alive = true;
    setLoading(true);
    fetchCustomer(id)
      .then((data) => {
        if (!alive || !data) return;
        setForm({
          name: data.name || '',
          code: data.code || '',
          note: data.note || '',
        });
      })
      .catch((err) => {
        if (alive) setError(err.message || 'โหลดลูกค้าไม่สำเร็จ');
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, [id, isEdit]);

  function setField(key, value) {
    setForm((prev) => ({ ...prev, [key]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.name.trim()) return;
    setSaving(true);
    setError('');
    try {
      if (isEdit) {
        await updateCustomer(id, form);
      } else {
        await createCustomer(form);
      }
      navigate('/customers', { replace: true });
    } catch (err) {
      setError(err.message || 'บันทึกไม่สำเร็จ');
    } finally {
      setSaving(false);
    }
  }

  if (loading) {
    return (
      <div className="stack">
        <div className="card muted">กำลังโหลด...</div>
      </div>
    );
  }

  return (
    <div className="stack">
      <header className="data-hero">
        <div>
          <p className="data-kicker">ลูกค้า</p>
          <h1>{isEdit ? 'แก้ไขลูกค้า' : 'เพิ่มลูกค้า'}</h1>
          <p className="muted data-sub">
            {isEdit ? 'แก้ไขข้อมูลแล้วกดบันทึก' : 'กรอกข้อมูลแล้วกดบันทึก'}
          </p>
        </div>
      </header>

      <form className="card stack" onSubmit={handleSubmit}>
        <div className="field">
          <label htmlFor="customer-name">ชื่อลูกค้า *</label>
          <input
            id="customer-name"
            value={form.name}
            onChange={(e) => setField('name', e.target.value)}
            placeholder="เช่น บริษัท ABC"
            required
            autoComplete="organization"
          />
        </div>
        <div className="field">
          <label htmlFor="customer-code">รหัส</label>
          <input
            id="customer-code"
            value={form.code}
            onChange={(e) => setField('code', e.target.value)}
            placeholder="เช่น CUS-01"
            autoComplete="off"
          />
        </div>
        <div className="field">
          <label htmlFor="customer-note">หมายเหตุ</label>
          <input
            id="customer-note"
            value={form.note}
            onChange={(e) => setField('note', e.target.value)}
            placeholder="รายละเอียดเพิ่มเติม"
            autoComplete="off"
          />
        </div>

        {error ? <p style={{ color: 'var(--ng)', margin: 0 }}>{error}</p> : null}

        <div className="stack" style={{ gap: '0.5rem', marginTop: '0.25rem' }}>
          <button className="btn btn-primary" type="submit" disabled={saving}>
            {saving ? 'กำลังบันทึก...' : isEdit ? 'บันทึก' : 'เพิ่มลูกค้า'}
          </button>
          <Link className="btn" to="/customers">
            ยกเลิก
          </Link>
        </div>
      </form>
    </div>
  );
}
